<template>
  <div class="attach column label wrap">
    <div class="row wrap">
      <div class="grid-6-s grid-3">
        Cliente
        <br />
        <strong>{{ job.nome_cliente }}</strong>
      </div>
      <div class="grid-6-s grid-5">
        Atendimento
        <br />
        <strong>{{ job.forma_atendimento }}</strong>
      </div>
      <div class="grid-6-s grid-4 status">
        Status
        <br />
        <strong>{{ job.status.replace("Doutor", "Supporter") }}</strong>
      </div>
    </div>
    <div class="grid-12 column">
      <div class="file row align-center grid-12">
        <div class="field grid-8 grid-6-s">
          <div
            class="filler row align-center"
            :style="`width: ${file.percentLoaded}%`"
          >
            {{ file.name || file.percentLoaded + "%" }}
          </div>
        </div>
        <button
          class="grid-4 grid-6-s"
          onclick="document.getElementById('attach').click()"
        >
          SELECIONAR ARQUIVOS
        </button>
      </div>
      <input
        id="attach"
        type="file"
        ref="files"
        @change="loadFile"
        class="hide"
      />
      <div class="type">
        Tipos de arquivos permitidos:
        <b>JPG, JPEG, PNG e PDF</b>
        <br />Tamanho máximo do arquivo:
        <b>10MB</b>
      </div>
    </div>
    <div class="divider"></div>
    <div class="row grid-12 justify-center">
      <div class="grid-4-g justify-center row">
        <Button
          layout="green-go"
          @click="
            submitFiles();
            modal.show = false;
          "
          >SALVAR ARQUIVOS</Button
        >
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.attach {
  padding: 10px 30px;
  padding-top: 25px;
  padding-bottom: 25px;
  color: $gray-6;
  font-size: 15px;
  @media (min-width: $small) {
    width: 600px;
  }
  .button-green-go {
    margin-top: 40px;
  }
  strong {
    font-weight: 500;
    color: $gray-1;
  }
  .type {
    margin-top: 25px;
    margin-bottom: 35px;
    @media (max-width: $small) {
      font-size: 0.7rem;
    }
  }
  .file {
    margin-top: 25px;
    .filler {
      background: $green-8;
      height: 40px;
      padding-left: 10px;
      color: $white;
      font-weight: bold;
      @media (max-width: $small) {
        font-size: 0.7rem;
      }
    }
    .field {
      height: 40px;
      background: #f2f2f2 0% 0% no-repeat padding-box;
      border: 1px solid #dbdbdb;
      border-radius: 5px 0px 0px 5px;
      opacity: 1;
    }
    button {
      height: 42px;
      background: $green-9 0% 0% no-repeat padding-box;
      border-radius: 0px 5px 5px 0px;
      opacity: 1;
      color: $white;
      font-weight: bold;
    }
  }
  .status {
    @media (max-width: $small) {
      margin-top: 12px;
    }
  }
}
</style>

<script>
import { mapActions, mapGetters } from "vuex";
import Button from "@/components/Button";

export default {
  name: "Attach",
  props: {
    modal: Object,
  },
  components: {
    Button,
  },
  data() {
    return {
      file: { name: "", percentLoaded: 0 },
      files: "",
      job: this.GET_JOB(),
      loader: true,
      allow: false,
    };
  },
  methods: {
    ...mapActions("job", ["SET_ATTACH"]),
    ...mapGetters("job", ["GET_JOB"]),

    loadFile(f) {
      this.allow = false;
      this.files = this.$refs.files.files;
      this.file = { name: "", percentLoaded: 0 };
      var file = f.target.files || f.dataTransfer.files;
      file = file[0];
      if (file) {
        let reader = new FileReader();
        reader.readAsBinaryString(file);
        reader.onprogress = (e) => {
          if (e.lengthComputable)
            this.file.percentLoaded = Math.round((e.loaded / e.total) * 100);
        };

        reader.onload = (e) => {
          // eslint-disable-next-line no-unused-vars
          var contents = e.target.result;
          if (
            file.type.match("image/jpeg|image/png|image/jpg|application/pdf")
          ) {
            this.allow = true;
          } else {
            this.file.name = "TIPO DE ARQUIVO NÃO PERMITIDO";
          }
        };
      }
    },
    submitFiles() {
      if (this.allow) {
        var formData = new FormData();
        formData.append("arquivo", this.files[0]);
        this.SET_ATTACH({ id: this.job.id, arquivo: formData });
      }
    },
  },
};
</script>
